export default "__VITE_ASSET__DqdZTYbZ__"